import {AdGroupForm} from 'common/pages/ad-group/AdGroupForm'

export const AdGroupFormAgency = (props) =>
    <AdGroupForm {...props} mode={props.mode} agency />